import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root {
    --rose-gold: #b76e79;
  }

  body {
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.text};
    font-family: 'Arial', sans-serif;
    margin: 0;
    padding: 0;
    transition: background-color 0.3s, color 0.3s;
  }

  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    transition: color 0.3s;
  }

  a:hover {
    color: ${props => props.theme.colors.secondary};
    text-decoration: underline;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    color: var(--rose-gold);
  }

  .nav-link {
    color: ${props => props.theme.colors.text};
  }

  p {
    line-height: 1.6;
    color: ${props => props.theme.colors.textSecondary};
  }

  button {
    cursor: pointer;
    transition: all 0.3s ease;
  }

  * {
    box-sizing: border-box;
  }
`;

export default GlobalStyle;